import { LocalShipping } from '@mui/icons-material';
import styled from 'styled-components';

export const ContainerBox = styled.div`
  border-radius: 4px;
  color: ${({ theme }) => theme.pantoneBlack};
  box-shadow:
    0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  overflow-x: auto;
  padding: 10px;
  padding-top: 0;
`;

export const HeaderBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
  }
`;

export const ContainerTitleBox = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
  }
`;

export const TitleBox = styled.h6`
  font-weight: bold;
  margin: 0;
`;

export const BodyBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 0.5rem;
  border: 1px solid ${({ theme }) => theme.pantone642C};
  border-radius: 4px;
`;

export const ContainerPart = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.4rem;

  > img {
    object-fit: contain;
    padding: 5px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.4rem;
  }
`;

export const ColumnPart = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
  }
`;

export const PartInfo = styled.div`
  width: 550px;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 500px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 160px;
  }
`;

export const ContainerPartPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 0 0 0 auto;

  > h6 {
    font-weight: bold;
    margin: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 0;
  }
`;

export const IconShipping = styled(LocalShipping)`
  &&& {
    transform: rotateY(180deg);
  }
`;

export const ContainerDelivery = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;

export const ContainerDeliveryPrice = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
  }
`;

export const ContainerInfoDelivery = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
`;

export const Quantity = styled.div`
  border: 1px solid ${({ theme }) => theme.pantone2726C};
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20%;
  margin: 0 1rem;
`;

export const TextFreeShipping = styled.h6`
  color: ${({ theme }) => theme.pantone2727C};
  margin-left: 0.5rem;
  margin-top: 0;
`;

export const Reason = styled.div`
  margin: 1rem;
  flex: 1;
  text-align: center;
`;
